import { render, staticRenderFns } from "./xlhsz.vue?vue&type=template&id=29a552a8&scoped=true&"
import script from "./xlhsz.vue?vue&type=script&lang=js&"
export * from "./xlhsz.vue?vue&type=script&lang=js&"
import style0 from "./xlhsz.vue?vue&type=style&index=0&id=29a552a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a552a8",
  null
  
)

export default component.exports